import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      {/* footer start here */}
      <footer className="footer pt-5 pb-5">
        <div className="container">
          <div className="row justify-content-between mb-5 g-xl-5">
            <div className="col-md-4 mb-5 mb-lg-0">
              <a className="navbar-brand w-auto" href="/">
                <img
                  className="logo dark img-fluid w-[200px] mb-3"
                  src="assets/images/logo.png"
                  alt="Brand Logo"
                />
              </a>
              <p className="mb-4">
               Vedana Care supports individuals and families with accessible OPD and preventive wellness plans.
              </p>
            </div>
            <div className="col-md-7">
              <div className="row g-2">
                <div className="col-md-6 col-lg-4 mb-4 mb-lg-0">
                  <h3 className="mb-3">Company</h3>
                  <ul className="list-unstyled">
                    <li>
                      <a href="/plans">Plans <span className="badge ms-1">New</span></a>
                    </li>
                    <li>
                      <a href="/contact">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6 col-lg-4 mb-4 mb-lg-0">
                  <h3 className="mb-3">Terms & Policies</h3>
                  <ul className="list-unstyled">
                    <li>
                      <a href="/term-of-use">Term & Conditions</a>
                    </li>
                    <li>
                      <a href="/shipping-delivery-policy">Shipping & Delivery</a>
                    </li>
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/cancellation-policy">Cancellation Policy</a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6 col-lg-4 mb-4 mb-lg-0 quick-contact">
                  <h3 className="mb-3">Contact</h3>
                  <p className="d-flex mb-3">
                    <i className="bi bi-geo-alt-fill me-3" />
                    <span>
                      S-8/314 Hukulganj, Hukulganj, Varanasi, Uttar Pradesh, India - 221002
                    </span>
                  </p>
                  <a className="d-flex mb-3" href="mailto:support@vedanacare.com">
                    <i className="bi bi-envelope-fill me-3" />
                    <span>support@vedanacare.com</span>
                  </a>
                  <a className="d-flex mb-3" href="tel:+91 7081003111">
                    <img src="assets/images/male.png" alt="For Male Phone Number" className="me-3 w-[24px]" />
                    <span>+91 7081003111</span>
                  </a>
                  <a className="d-flex mb-3" href="tel:+91 7081003111">
                    <img src="assets/images/female.png" alt="For Male Phone Number" className="me-3 w-[24px]" />
                    <span>+91 7081003222</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row credits pt-3">
            <div className="col-xl-6 text-center text-xl-start mb-3 mb-xl-0">
              © Vedana Care 2026. All rights reserved
            </div>
            <div className="col-xl-6 text-center text-xl-end mb-3 mb-xl-0 font-semibold">
              In Association With KSHITIZ TRADE AND MULTISERVICES PRIVATE LIMITED
            </div>
          </div>
        </div>
      </footer>

      {/* footer ends here */}

    </div>
  );
};

export default Footer;
